import api from './api'

const asanaOAuthService = {
  async initiateOAuthFlow() {
    const response = await api.get('/asana_oauth/authorize')
    const { authorize_url: authorizeUrl } = response.data

    const width = 600
    const height = 700
    const left = window.screen.width / 2 - width / 2
    const top = window.screen.height / 2 - height / 2

    const popup = window.open(
      authorizeUrl,
      'asana_oauth',
      `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=yes,resizable=yes`
    )

    if (!popup) {
      throw new Error('Popup blocked. Please allow popups for this site.')
    }

    return new Promise((resolve, reject) => {
      const checkClosed = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkClosed)
          this.getStatus()
            .then((status) => {
              if (status.connected) resolve()
              else reject(new Error('Authorization was not completed'))
            })
            .catch(reject)
        }
      }, 500)

      const messageHandler = (event) => {
        if (event.data?.type === 'asana_oauth_success') {
          clearInterval(checkClosed)
          window.removeEventListener('message', messageHandler)
          popup.close()
          resolve()
        } else if (event.data?.type === 'asana_oauth_error') {
          clearInterval(checkClosed)
          window.removeEventListener('message', messageHandler)
          popup.close()
          reject(new Error(event.data.error || 'OAuth authorization failed'))
        }
      }

      window.addEventListener('message', messageHandler)

      setTimeout(() => {
        if (!popup.closed) popup.close()
        clearInterval(checkClosed)
        window.removeEventListener('message', messageHandler)
        reject(new Error('OAuth authorization timed out'))
      }, 300000)
    })
  },

  async getStatus() {
    const response = await api.get('/asana_oauth/status')
    return response.data
  },

  async revoke() {
    await api.post('/asana_oauth/revoke')
  },
}

export default asanaOAuthService
